import { render, staticRenderFns } from "./Feeder.vue?vue&type=template&id=067b6b1b&scoped=true"
import script from "./Feeder.vue?vue&type=script&lang=js"
export * from "./Feeder.vue?vue&type=script&lang=js"
import style0 from "./Feeder.vue?vue&type=style&index=0&id=067b6b1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067b6b1b",
  null
  
)

export default component.exports